module.exports = __webpack_public_path__ + "jhu2-512146c75508129a8288f0703ad60347.png";